import { useForm } from "react-hook-form";
import "./Contact.scss"
import { useState } from "react";

type FormData = {
    name: string;
    email: string;
    phone: string;
    message: string;
}

const EMAIL_PATTERN = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

function Contact() {

    const { handleSubmit, register, reset, formState: { errors } } = useForm<FormData>({
        defaultValues: {
            name: '',
            email: '',
            message: ''
        }
    });
    const [showAlert, setShowAlert] = useState(false);
    const [isLoading, setLoading] = useState(false);

    const onSubmit = async (data: any) => {
        setLoading(true);
        try {
            await fetch(process.env.REACT_APP_GOOGLE_SCRIPT_URL!, {
                method: "POST",
                body: JSON.stringify(data),
            });
            setShowAlert(true);
            reset();
            setTimeout(() => {
                setShowAlert(false);
            }, 6000);
        } catch (error) {
            alert("Something went wrong");
        } finally {
            setLoading(false);
        }
    }


    return (
        <section id="contact" className="contact">
            <div className="background"></div>
            <div className="container">
                <div className="card">
                    <div className="content">

                        <div className="title-wrap">
                            <p className="pre-title">
                                Let's Get In Touch And
                                {/* <em>And</em> */}
                            </p>
                            <h1 className="title">
                                <span>Build  Something</span>
                                {/* <span>Something</span> */}
                                <span>Remarkable</span>
                            </h1>
                            <p className="subtitle">
                                Open to freelance projects, full-time roles, and creative collaborations. If you have an idea worth designing, I'd love to hear about it.
                            </p>

                            {/* <a href="mailto:mayank05sh@gmail.com" className="ct__email">
                                mayank05sh@gmail.com
                                <span className="ct__email-arrow">↗</span>
                            </a> */}
                            {/* <img src="/ms-logo.webp" alt="Logo" className="card-logo" /> */}
                            <div className="ct__footer">
                                <img src="/ms-logo.webp" alt="Logo" className="card-logo" />

                                <a href="mailto:mayank05sh@gmail.com" className="ct__email">
                                    mayank05sh@gmail.com
                                    <span className="ct__email-arrow">↗</span>
                                </a>
                            </div>

                        </div>

                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="form-field">
                                <label htmlFor="name">Full Name</label>
                                <input id="name" type="text" {...register("name", { required: true, maxLength: 30 })} className={errors.name ? "input-error" : ""} />
                                {errors.name?.type === "required" && (<p role="alert" className="error">Name is required</p>)}
                            </div>

                            <div className="form-field">
                                <label htmlFor="email">Email</label>
                                <input id="email" type="email" {...register("email", { required: true, pattern: EMAIL_PATTERN })} className={errors.email ? "input-error" : ""} />
                                {errors.email?.type === "required" && (<p role="alert" className="error">Email is required</p>) || (errors.email?.type === 'pattern' && (<p role="alert" className="error">Enter a valid email</p>))}
                            </div>

                            {/* <div className="row">
                                <div>
                                    <label>Email</label>
                                    <input type="email" {...register("email", { required: true, pattern: EMAIL_PATTERN })} className={errors.email ? "input-error" : ""} />
                                </div>
                                <div>
                                    <label>Phone</label>
                                    <input type="tel" {...register("phone")} {...register("phone", { required: true })} className={errors.phone ? "input-error" : ""} />
                                </div>
                            </div> */}

                            <div className="form-field">
                                <label htmlFor="message">Message</label>
                                <textarea id="message" {...register("message", { required: true })} className={errors.message ? "input-error" : ""}></textarea>
                                {errors.message?.type === "required" && (<p role="alert" className="error">Message is required</p>)}
                            </div>
                            {/* 
                            {
                                isLoading ?
                                    <span className="loader"></span>
                                    :
                                    <div className="submit-wrap">
                                        <button type="submit" className="submit">→</button>
                                        <span className="submit-text">Submit</span>
                                    </div>
                            } */}

                            <div className="ct__submit-row">
                                <span className="ct__note">I reply within 24 hours.</span>
                                {
                                    isLoading ?
                                        <span className="loader"></span>
                                        :
                                        <button type="submit" className="ct__btn">
                                            Send it <span className="ct__btn-arrow">↗</span>
                                        </button>
                                }
                            </div>


                            {showAlert && (
                                <div className="toast-alert">
                                    <span>Thank you for submitting your query. I’ll get back to you soon!</span>
                                    <button
                                        className="toast-close"
                                        onClick={() => setShowAlert(false)}
                                        aria-label="Close alert"
                                    >
                                        ✕
                                    </button>
                                </div>
                            )}


                        </form>

                        {/* <img src="/ms-logo.webp" alt="Logo" className="card-logo" /> */}
                    </div>
                </div>

            </div>
        </section>
    )
}

export default Contact;